import { elementController } from '@public-pages/runtime-core';

elementController('external-content', ({ queryAll }) => {
  const linkBtnList = queryAll('.content-slider__link') as HTMLButtonElement[];

  linkBtnList.forEach(linkBtn => {
    linkBtn.addEventListener('click', () => handleBtnClick(linkBtn));
  })

  function handleBtnClick(btnLink: HTMLButtonElement) {
    const link = btnLink.dataset.link;
    window.open(link, "_blank");
  }
});
